import React, { Fragment } from 'react'
import UseCase1Frame1 from 'src/components/use-case-1-frame-1'
import UseCase2Frame1 from 'src/components/use-case-2-frame-1'
import UseCase3Frame1 from 'src/components/use-case-3-frame-1'
import UseCase4Frame1 from 'src/components/use-case-4-frame-1'
import UseCase5Frame1 from 'src/components/use-case-5-frame-1'
import UseCase6Frame1 from 'src/components/use-case-6-frame-1'
import UseCase7Frame1 from 'src/components/use-case-7-frame-1'
import UseCase8Frame1 from 'src/components/use-case-8-frame-1'

export default [
  {
    id: 'use-case-1',
    buttonLabel: 'China Improve mobile conversion rate',
    frames: UseCase1Frame1,
    introCopy: (
      <p>
        China It's a fact: most of your traffic is mobile [footnote: Criteo piece]. When a mobile user clicks
        your partners' links, are they going to mobile web? Your app? The app store? If you want to see better
        mobile conversion rates, you need a better mobile user experience.
      </p>
    ),
    description: (
      <p>
        If the user already has your app installed, it’s a no-brainer to send them into your app whenever they
        click one of your links on the web. But what if they don’t have your app? You should let the user
        choose whether to open the page in mobile web or download your app. And once they download your app,
        they should be taken directly to the product they clicked on as soon as they open your app for the
        first time.
      </p>
    ),
    content1: {
      copy1: 'A user clicks on a product link',
      copy2: 'Is the app installed?',
      button1: '国',
      button2: '是',
    },
    content2: {
      copy1: 'Success!',
      copy2: 'A user clicks on a product link',
      button1: 'Start Over',
    },
    content3: {
      copy1: 'Install app or continue in mobile browser?',
      button1: 'App',
      button2: 'Browser',
      button3: 'Back',
    },
    content4: {
      copy1: 'App',
      copy2: 'The user is prompted to download the app.',
      button1: 'Install the app',
      button2: 'Back',
    },
  },
  {
    id: 'use-case-2',
    buttonLabel: 'Outdated offers',
    frames: UseCase2Frame1,
    introCopy: (
      <Fragment>
        <p>
          You want a wide variety of partners promoting your offers — but what if they don't update when you
          change it? After all, you don't have any direct control over how quickly they swap out the link on
          their site.
        </p>
        <p>
          Oh wait. Yes, you do. With TrueLink, you can simply mark an offer or link as no longer valid. So
          even when customers click that outdated link, you can show them a message that the offer is no
          longer available or simply redirect them to the current offer."
        </p>
      </Fragment>
    ),
    description: (
      <p>
        Here's a scenario: you're promoting a credit card. The interest rate has just gone up, but your
        partner is still promoting the old interest rate. Normally, this would be a regulatory nightmare. With
        TrueLink, you can interject a message before they land on your site, and even require the user to
        acknowledge that the offer has changed. Then you can simply show them the new offer!
      </p>
    ),
  },
  {
    id: 'use-case-3',
    buttonLabel: 'Location-based promos',
    frames: UseCase3Frame1,
    introCopy: (
      <p>
        If you're looking to drive conversions in a specific location — say, New York — the natural thing to
        do is offer a location-specific discount. But this is the internet. "Meg" in New York can forward the
        offer to "Tom" in Seattle, and before you know it, people all over the world are using the deal you
        intended just for New Yorkers. Let's fix that.
      </p>
    ),
    description: (
      <p>
        Since we can see the IP address of anyone clicking on a partner's link, TrueLink can automatically
        decide whether to route a user to a location-specific page. So rather than provide a special (and
        easily transferrable) code to the people you think are in New York, you can just set up a separate
        landing page and route anyone with a New York IP address to that page. Oh, and you can do it with
        in-app locations as easily as web pages.
      </p>
    ),
  },
  {
    id: 'use-case-4',
    buttonLabel: 'Instant loyalty partnerships',
    frames: UseCase4Frame1,
    introCopy: (
      <p>
        Let's say you want to work with an airline. They'll promote your products within their loyalty portal,
        and you'll give their users free miles when they purchase. How do you make it happen? Well, you could
        kick off a complicated integration and tracking process that requires input from several teams on both
        sides. Or you could pay the airline cash and rely on them to correctly convert to miles and deposit
        the right amount into the right account. Or (best answer!), you could use TrueLink
      </p>
    ),
    description: (
      <p>
        How does TrueLink help here? Once we see that a given user has clicked on the airline's link and is
        headed to your site, we can reroute them to an "interstitial" page. Essentially, we'll show them a
        popup that asks for their frequent flier number. If they enter a valid number, we can connect it to
        the eventual conversion and pass all that data back to you. You can then pass it to the airline, and
        they'll know exactly who (and how much) to credit.
      </p>
    ),
  },
  {
    id: 'use-case-5',
    buttonLabel: 'A/B testing mobile user experience',
    frames: UseCase5Frame1,
    introCopy: (
      <p>
        You already know how important it is to dial in your customers' mobile user experience. However, it
        doesn't stop there. Even once you've adopted our best practices, you need to always be on the lookout
        for ways to improve. That's where A/B testing comes in so you can find out what actions your users
        prefer.
      </p>
    ),
    description: (
      <Fragment>
        <p>
          "You can A/B test a few ways. The first scenario: a classic A/B landing page test. No problem. The
          second scenario is a bit more abstract . . . here, you test whether you get better overall results
          by sending users to complete their purchase on your mobile website, or whether it's best to send
          them to the app store and then complete their purchase in the app. It's more complicated, but
          TrueLink can help.{' '}
        </p>

        <p>
          Special tip: To see the whole picture, be sure to take into account not only conversions, but also
          the new app users you get from each approach."
        </p>
      </Fragment>
    ),
  },
  {
    id: 'use-case-6',
    buttonLabel: 'A/B testing: product landing pages',
    frames: UseCase6Frame1,
    introCopy: (
      <Fragment>
        <p>
          "Sticking to the theme of ""always be testing,"" it's also important to continually optimize your
          product landing pages. With TrueLink, you can test in both mobile web and your app.
        </p>
        <p>
          Plus, you can layer in extra conditionals— for example, you can test certain landing pages only if
          the traffic is coming from a specific partner."
        </p>
      </Fragment>
    ),
    description: (
      <p>
        Here's how. First, TrueLink identifies whether the user has your app installed. Then, it determines
        whether the user is headed to the page you're trying to test. If not, then TrueLink simply lets the
        user go wherever they were going. If they are going to the product page you want to test, TrueLink
        will randomly assign the user to the test or control group, and reroute them to the appropriate page
        or in-app location.
      </p>
    ),
  },
  {
    id: 'use-case-7',
    buttonLabel: 'Personalization',
    frames: UseCase7Frame1,
    introCopy: (
      <p>
        Some partners — especially sites such as loyalty portals that require users to log in — have a great
        deal of data on their users' shopping habits. If your partner knows which categories their users tend
        to purchase, you can use TrueLink to quickly direct them to the place they're most likely to convert.
      </p>
    ),
    description: (
      <p>
        For example, let's say a user clicks your partner's link to your home page. If they don't have any
        data on that user, then TrueLink will just send the user to your home page as expected. However, if
        they happen to know that the user frequently shops for, say, sporting goods or beauty products,
        TrueLink can absorb that data and dynamically send the user to a specific category page instead.
      </p>
    ),
  },
  {
    id: 'use-case-8',
    buttonLabel: 'Time-sensitive promos',
    frames: UseCase8Frame1,
    introCopy: (
      <p>
        We've all been there: a major sale has come and gone, but a few partners are still hosting links to
        pages of now-outdated deals. You don't want to replace the page entirely, but you also don't want your
        customers to land there. Sounds like a job for TrueLink!
      </p>
    ),
    description: (
      <p>
        With TrueLink, you can set date- and time-based rules for any URL. So for example, as long as it's
        still the day after Thanksgiving, any link to the Black Friday page will work just fine. But
        afterward, you can automatically route traffic elsewhere. This prevents your customers from feeling
        like they missed out, and gives you a good way to highlight the deals they still can take advantage of
        — all without relying on your partners to swap any URLs.
      </p>
    ),
  },
]
